import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 text-lg font-heading font-bold text-foreground-900 mb-4">
              <span className="w-7 h-7 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-heart-fill text-background-50 text-xs"></i>
              </span>
              蜜桃网站
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              精选内容聚合平台，海量资源一站直达。为您提供科技、娱乐、生活、美食、健康、财经等多元化优质内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">内容分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  加入我们
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  广告合作
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  内容投稿
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系方式</h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                <span>contact@weifutongmicropay.cn</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line mt-0.5 text-foreground-400"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line mt-0.5 text-foreground-400"></i>
                <span>北京市朝阳区望京SOHO</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 蜜桃网站 - 精选内容聚合平台。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}